import {
  SortEnum,
  useCountMembersQuery,
  UserWorkspaceStatusEnum,
  WorkspaceMembersV2Query,
  WorkspaceMembersV2QueryVariables,
} from '@/types/generated/graphql';
import { useState } from 'react';
import { useCursorPagination } from '@shared/hooks/use-cursor-pagination';
import { CURSOR_WORKSPACE_MEMBERS_V2 } from '@/graphql/cursor.graphql';
import { WorkspaceMembersFilter } from '../members.types';
import { SelectMemberTypeEnum } from '@modules/teams/teams.types';

export function useWorkspaceMembers() {
  const [filter, setFilter] = useState<WorkspaceMembersFilter>({
    query: '',
    sort: SortEnum.ASC,
    status: UserWorkspaceStatusEnum.accepted,
    order: 'createdAt',
    role: null,
    teams: null,
  });
  const { data, initialLoading, hasNextPage, loadNextRef, loading } = useCursorPagination<
    WorkspaceMembersV2Query,
    WorkspaceMembersV2QueryVariables
  >({
    schema: CURSOR_WORKSPACE_MEMBERS_V2,
    responseDataKey: 'workspaceMembersV2',
    variables: filter,
  });
  const { data: membersCountData } = useCountMembersQuery({
    variables: {
      query: filter?.query,
    },
  });
  const adminCount = membersCountData?.countMembers?.data?.find((item) => item?.key === 'admin')?.value || 0;
  const memberCount = membersCountData?.countMembers?.data?.find((item) => item?.key === 'member')?.value || 0;

  function handleSortMember(order: string) {
    setFilter((prev) => ({
      ...prev,
      order: order,
      sort: order === SelectMemberTypeEnum.name ? SortEnum.ASC : SortEnum.DESC,
    }));
  }
  return {
    data,
    setFilter,
    loadNextRef,
    filter,
    loading,
    hasNextPage,
    initialLoading,
    handleSortMember,
    memberCount,
    adminCount,
  };
}
